module.exports = __webpack_public_path__ + "img/pxh.1b50162f.jpg";